import React from 'react';
import type { CalculatorStepProps } from '../../types/claimCalculator';
const inputClass = 'min-h-[46px] w-full rounded-input border border-ink/15 bg-canvas px-3.5 text-[13px] text-ink outline-none placeholder:text-slate/55 focus:border-forest focus:ring-2 focus:ring-signal/30';
export function YourDetailsStep({
  data,
  update
}: CalculatorStepProps) {
  return <div className="space-y-3" data-id="element-131" data-mp="85mq0uiyflqp">
      <p className="text-small font-semibold text-ink" data-id="element-132" data-mp="m29nqziqefxo">Your details</p>
      <div className="grid gap-3 sm:grid-cols-2" data-id="element-133" data-mp="h3yeor09g9gi">
        <label className="text-[12px] font-semibold text-slate" data-id="element-134" data-mp="h36v6ejxu26l">
          Your name
          <input value={data.name} onChange={event => update('name', event.target.value)} autoComplete="name" className={`mt-1 ${inputClass}`} required data-id="element-135" data-mp="vrt706acwbt2" />
        </label>
        <label className="text-[12px] font-semibold text-slate" data-id="element-136" data-mp="14rgaqyqk5tpa">
          Date of birth
          <input type="date" value={data.dateOfBirth} onChange={event => update('dateOfBirth', event.target.value)} autoComplete="bday" className={`mt-1 ${inputClass}`} required data-id="element-137" data-mp="10tsarha0daqj" />
        </label>
        <label className="text-[12px] font-semibold text-slate" data-id="element-138" data-mp="1hbyzq75j8yhz">
          Mobile number
          <input type="tel" value={data.mobile} onChange={event => update('mobile', event.target.value)} autoComplete="tel" className={`mt-1 ${inputClass}`} required data-id="element-139" data-mp="1mcuyy7exvwh2" />
        </label>
        <label className="text-[12px] font-semibold text-slate" data-id="element-140" data-mp="203i0e7c340gu">
          Email address
          <input type="email" value={data.email} onChange={event => update('email', event.target.value)} autoComplete="email" className={`mt-1 ${inputClass}`} required data-id="element-141" data-mp="252bdhynglpgh" />
        </label>
      </div>
    </div>;
}